/**
 * Welle 7d — ICE-Server laden.
 *
 * Bevorzugt kurzlebige TURN-Credentials inkl. TURNS:443 (`/api/turn/credentials`,
 * für Gäste hinter strengen Firewalls), mit robustem Fallback:
 *   1) /api/turn/credentials  (kurzlebig + TURNS:443, sobald coturn use-auth-secret fährt)
 *   2) /api/ice-servers        (bestehendes statisches IceModule)
 *   3) STUN-Notfall
 *
 * Wirft NIE — liefert immer ein gültiges RTCIceServer[]. Solange der credentials-
 * Endpoint 503/404 meldet (coturn noch nicht umgestellt), greift transparent (2).
 */
const STUN: RTCIceServer[] = [{ urls: 'stun:stun.l.google.com:19302' }];

export async function loadIceServers(): Promise<RTCIceServer[]> {
  // 1) Kurzlebige Credentials + TURNS:443
  try {
    const r = await fetch('/api/turn/credentials');
    if (r.ok) {
      const d = await r.json();
      if (d && Array.isArray(d.urls) && d.urls.length && d.username && d.credential) {
        return [{ urls: d.urls, username: d.username, credential: d.credential }, ...STUN];
      }
    }
  } catch {
    /* weiter zum Fallback */
  }
  // 2) Statisches IceModule
  try {
    const r = await fetch('/api/ice-servers');
    if (r.ok) {
      const d = await r.json();
      const list = d?.iceServers ?? d;
      if (Array.isArray(list) && list.length) return list;
    }
  } catch {
    /* weiter zum Fallback */
  }
  // 3) Notfall
  return STUN;
}
